import * as tslib_1 from "tslib";
import { PlaneClassification } from "@awayjs/core";
import { BoundingVolumeBase } from "../bounds/BoundingVolumeBase";
var NullBounds = (function (_super) {
    tslib_1.__extends(NullBounds, _super);
    function NullBounds(alwaysIn) {
        if (alwaysIn === void 0) { alwaysIn = true; }
        var _this = _super.call(this, null) || this;
        _this._alwaysIn = alwaysIn;
        return _this;
    }
    //@override
    NullBounds.prototype.clone = function () {
        return new NullBounds(this._alwaysIn);
    };
    //@override
    NullBounds.prototype.isInFrustum = function (planes, numPlanes) {
        return this._alwaysIn;
    };
    NullBounds.prototype.classifyToPlane = function (plane) {
        return PlaneClassification.INTERSECT;
    };
    return NullBounds;
}(BoundingVolumeBase));
export { NullBounds };



// WEBPACK FOOTER //
// ../dist/lib/bounds/NullBounds.js